<template>
  <el-dialog title='预览' :visible.sync='dialogVisible' center
             @close='dialogClose' width='100vw' :close-on-click-modal='false' class='PDF-dialog'
             append-to-body>
    <div class='container' v-loading='dialogLoading'>
      <iframe :src='pdfUrl' width='100%' height='100%'></iframe>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios';
  import { baseImgUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    name: 'PDFPreview',
    data() {
      return {
        pdfUrl: '',
        dialogVisible: false,
        dialogLoading: false,
        fileUrl: '/public/plugin/pdfjs2/web/viewer.html?file=',
      };
    },
    methods: {
      dialogClose() {
        this.dialogVisible = false;
      },
      loadPDF(id) {
        this.dialogVisible = true;
        this.dialogLoading = true;
        axios({
          method: 'post',
          url: baseImgUrl + `/web/attachmentFtp/download?attachmentId=${id}`,
          responseType: 'blob',
          headers: {
            Accept: 'application/octet-stream',
            token: getSessionStore('token'),   // 获取token，这里假定 myToken
          },
        })
          .then(res => {
            let blob = new Blob([res.data], {
              type: 'application/pdf;charset-UTF-8',
            });
            this.pdfUrl = URL.createObjectURL(blob);
            this.dialogLoading = false;
            console.log(this.pdfUrl);
          })
          .catch(err => {
            console.log(err);
            this.dialogLoading = false;
          });
      },
    },
  };

</script>

<style lang='scss' scoped>
  ::v-deep {
    .el-dialog {
      height: 100vh !important;
      margin-top: 0 !important;
    }

    .el-dialog__body {
      overflow: hidden !important;
      max-height: 97vh !important;
    }
  }

  .container {
    height: 100vh;
  }

  .PDF-dialog {
    overflow: hidden;
  }
</style>
